export const DELAY_BEFORE_HIDE_ICON_DONE = 3000;
